import { render, staticRenderFns } from "./CmgErrorModal.vue?vue&type=template&id=6302e6b9&scoped=true&lang=pug&"
import script from "./cmg-error-modal.ts?vue&type=script&lang=ts&"
export * from "./cmg-error-modal.ts?vue&type=script&lang=ts&"
import style0 from "./CmgErrorModal.vue?vue&type=style&index=0&id=6302e6b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6302e6b9",
  null
  
)

export default component.exports